import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!$props.parentValue.length)
    ? (_openBlock(), _createBlock($setup["BaseInput"], {
        key: 0,
        class: "company-input",
        type: "text",
        name: $props.name,
        value: $setup.inputValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputValue) = $event))
      }, null, 8 /* PROPS */, ["name", "value"]))
    : _createCommentVNode("v-if", true)
}